import { Injectable } from '@angular/core';
import { ImageHandler, VideoHandler } from 'ngx-quill-upload';
import * as Quill from 'quill';

Quill.register('modules/imageHandler', ImageHandler);
Quill.register('modules/videoHandler', VideoHandler);

@Injectable()

export class QuillService {

  public minimal = {
    toolbar: {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{'size': ['small', false, 'large']}],
        ['code-block'],

        [{'color': []}, {'background': []}],
        [{'align': []}],

        ['link'],
      ],
    },
    formats: [
      'background',
      'bold',
      'color',
      'code',
      'italic',
      'link',
      'size',
      'underline',
      'indent',
      'list',
      'align',
      'code-block',
    ],
  };

  public quillEditor: any = null;

  constructor() {
  }

  maxLength(editor: any, length: number): void {
    if (editor.editor.getLength() > length) {
      editor.editor.deleteText(length, editor.editor.getLength());
    }
  }
}
